import {withLocalization} from '@epic-core/localization';
import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import React from 'react';

import StatsActions from '../../actions/StatsActions';
import LoadScreen from '../../components/loadScreen/LoadScreen';
import PlayerStats from '../../components/stats/PlayerStats';
import {StatsStore} from '../../stores';

const playlists = ['solo', 'duo', 'squad'];
const platforms = ['pc', 'ps4', 'xb1'];

@connectToStores
class StatsView extends React.Component {
  static propTypes = {
    statsStore: PropTypes.object,
    match: PropTypes.object,
    getMessage: PropTypes.func,
  };

  static getStores() {
    return [StatsStore];
  }

  static getPropsFromStores() {
    return {
      statsStore: StatsStore.getState(),
    };
  }

  static getInitialActions() {
    return [
      (props) => {
        StatsActions.getPlayerStats(props.match.params.displayName);
      },
    ];
  }

  state = {
    playlist: playlists[0],
    platform: platforms[0],
  };

  onChangePlaylist = (event) => {
    this.setState({
      playlist: event.target.value,
    });
  };

  onChangePlatform = (event) => {
    this.setState({
      platform: event.target.value,
    });
  };

  render() {
    const {loading, currentPlayer, playerStats} = this.props.statsStore;
    const {playlist, platform} = this.state;
    const {displayName} = this.props.match.params;
    const loadingStats = loading || displayName !== currentPlayer;
    return (
      <div id="stats" className="light-bg">
        <div className="container stats">
          <div className="site-block-heading-container text-center">
            <h1 className="site-block-page-title">{displayName}</h1>
          </div>
          <div className="site-block">
            <div className="col-sm-12 leaderboard-options">
              <select
                /*eslint-disable-line*/ name="platform"
                onChange={this.onChangePlatform}
                value={platform}>
                {platforms.map((platformOption) => (
                  <option key={platformOption} value={platformOption}>
                    {this.props.getMessage(`epic.fortnite.leaderboard.${platformOption}`)}
                  </option>
                ))}
              </select>
              <select
                /*eslint-disable-line*/ name="playlist"
                onChange={this.onChangePlaylist}
                value={playlist}>
                {playlists.map((playlistOption) => (
                  <option key={playlistOption} value={playlistOption}>
                    {this.props.getMessage(`epic.fortnite.leaderboard.${playlistOption}`)}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-12">
              <PlayerStats playerStats={playerStats} platform={platform} playlist={playlist} />
            </div>
            <div className="clearfix" />
          </div>
        </div>
        <LoadScreen show={loadingStats} />
      </div>
    );
  }
}

export default withLocalization(StatsView);
